import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
  MdOutlineSettings,
  MdCallToAction,
  MdCall,
  MdAutoGraph
} from "react-icons/md";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/dataTables";
import Transcripts from "views/admin/Transcripts";
import InitiateCall from "views/admin/initiateCall";
import NICLAnalytics from "views/admin/niclAnalytics";
import CallVolume from "views/admin/callVolume";
import WifiCalling3Icon from '@mui/icons-material/WifiCalling3';
import CallSimulation from "views/admin/callSimulation";

// Auth Imports
import SignInCentered from "views/auth/signIn";

const routes = [
  {
    name: "Initiate Call",
    layout: "/admin",
    // icon: <Icon as={MdOutlineSettings} width="20px" height="20px" color="inherit" />,
    icon: <Icon as={MdCall} width="20px" height="20px" color="inherit" />,
    path: "/initiateCall",
    component: InitiateCall,
    routeKey:"initiateCall",
    accessibleBy:"supervisor"
  },
  {
    name: "Analytics",
    layout: "/admin",
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    path: "/analytics",
    component: NICLAnalytics,
    routeKey:"analytics",
    accessibleBy:"supervisor"
  },
  {
    name: "Transcripts",
    layout: "/admin",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    path: "/transcripts",
    component: Transcripts,
    routeKey:"transcripts",
    accessibleBy:"admin"
  },
  {
    name: "Call Volume",
    layout: "/admin",
    icon: <WifiCalling3Icon width="20px" height="20px" color="inherit" />,
    path: "/callVolume",
    component: CallVolume,
    routeKey:"callVolume",
    accessibleBy:"supervisor"
  },
  {
    name: "QA",
    layout: "/admin",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    path: "/qa",
    component: Transcripts,
    routeKey:"qa",
    accessibleBy:"supervisor"
  },
    {
    name: "Call Simulation",
    layout: "/admin",
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    path: "/callSimulation",
    component: CallSimulation,
    routeKey:"callSimulation",
    accessibleBy:"admin"
  },


];

export const routeMapping = {
  // admin:["initiateCall","analytics","transcripts","callVolume","qa"],
  admin:["analytics","transcripts"],
  supervisor:["analytics","transcripts"],
  viewer:["analytics","transcripts"],
}

export function routesForRole(role){
  let extractedRoutes = []
  let routeKeys = routeMapping[`${role}`]
  for(let i=0;i<routeKeys.length;i++){
    for(let j=0;j<routes.length;j++){
      if(routeKeys[i]===routes[j].routeKey){
        extractedRoutes.push(routes[j])
      }
    }
  }

  return extractedRoutes
}


export default routes;
